import { render, staticRenderFns } from "./incomeInvoice.vue?vue&type=template&id=815b6f16&scoped=true&"
import script from "./incomeInvoice.vue?vue&type=script&lang=js&"
export * from "./incomeInvoice.vue?vue&type=script&lang=js&"
import style0 from "./incomeInvoice.vue?vue&type=style&index=0&id=815b6f16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815b6f16",
  null
  
)

export default component.exports